import { createSelector } from '@reduxjs/toolkit';

const recipeGroups = (state = {}) => state.recipeGroups;

export const getRecipeGroups = createSelector(
  recipeGroups,
  (recipeGroups) => recipeGroups.data
);

export const getRecipeGroupsStats = createSelector(
  recipeGroups,
  (recipeGroups) => recipeGroups.ui.stats
);

export const getRecipeGroupsLoading = createSelector(
  recipeGroups,
  (recipeGroups) => recipeGroups.ui.loading
);

export const creatingRecipesGroups = createSelector(
  recipeGroups,
  (recipeGroups) => recipeGroups.ui.creating
);

export const removeRecipesGroups = createSelector(
  recipeGroups,
  (recipeGroups) => recipeGroups.ui.deleting
);

export const getSingleRecipeGroup = createSelector(
  recipeGroups,
  (recipeGroups) => recipeGroups.single
);

export const getSingleRecipeGroupLoading = createSelector(
  recipeGroups,
  (recipeGroups) => recipeGroups.ui.fetchingSingle
);
